import { useTheme } from '@mui/material';

export const CompensationIcon = () => {
    const theme = useTheme();
    const {
        stroke: { secondary: secondaryStroke },
        background: { secondary: secondaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19 50.1965C19 41.8057 26.7031 35.5474 35.0931 35.6605C35.3951 35.6646 35.6976 35.6667 36 35.6667C36.3024 35.6667 36.6049 35.6646 36.9069 35.6605C45.2969 35.5474 53 41.8057 53 50.1965C53 52.1789 51.2074 53.6791 49.256 53.3297L41.779 51.9911C37.9567 51.3068 34.0433 51.3068 30.221 51.9911L22.744 53.3297C20.7926 53.6791 19 52.1789 19 50.1965Z"
                fill={secondaryBackground}
            />
            <path
                d="M45 25C45 29.9706 40.9706 34 36 34C31.0294 34 27 29.9706 27 25C27 20.0294 31.0294 16 36 16C40.9706 16 45 20.0294 45 25Z"
                fill={secondaryBackground}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M39 22C39 25.866 35.866 29 32 29C28.134 29 25 25.866 25 22C25 18.134 28.134 15 32 15C35.866 15 39 18.134 39 22ZM41 22C41 26.9706 36.9706 31 32 31C27.0294 31 23 26.9706 23 22C23 17.0294 27.0294 13 32 13C36.9706 13 41 17.0294 41 22ZM45.6084 48.361L38.1315 47.0224C34.0761 46.2964 29.9239 46.2964 25.8685 47.0224L18.3916 48.361C17.6663 48.4909 17 47.9333 17 47.1965C17 40.1435 23.5548 34.5591 31.0661 34.6603C31.3769 34.6645 31.6883 34.6667 32 34.6667C32.3117 34.6667 32.6231 34.6645 32.9339 34.6603C40.4452 34.5591 47 40.1435 47 47.1965C47 47.9333 46.3337 48.4909 45.6084 48.361ZM15 47.1965C15 38.8057 22.7031 32.5474 31.0931 32.6605C31.3951 32.6646 31.6976 32.6667 32 32.6667C32.3024 32.6667 32.6049 32.6646 32.9069 32.6605C41.2969 32.5474 49 38.8057 49 47.1965C49 49.1789 47.2074 50.6791 45.256 50.3297L37.779 48.9911C33.9567 48.3068 30.0433 48.3068 26.221 48.9911L18.744 50.3297C16.7926 50.6791 15 49.1789 15 47.1965Z"
                fill={secondaryStroke}
            />
        </svg>
    );
};
